<template>
  <div class="inner t-center">
    <div class="t-title sm mb-l icon">
      <svg width="19" height="34" viewBox="0 0 19 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.94624 30.3875C4.6853 29.9625 2.95556 28.9708 1.75699 27.4125C0.585663 25.8542 0 24.0125 0 21.8875L5.72043 21.4625C5.72043 23.8708 6.94624 25.075 9.39785 25.075C10.5419 25.075 11.4 24.8058 11.972 24.2675C12.5713 23.7008 12.871 23.0492 12.871 22.3125C12.871 21.6325 12.5577 21.1083 11.9312 20.74C11.3047 20.3717 10.5147 20.0317 9.56129 19.72C8.63512 19.4083 7.62724 19.0825 6.53763 18.7425C5.44803 18.4025 4.42652 17.935 3.47312 17.34C2.54695 16.7167 1.77061 15.9092 1.14409 14.9175C0.517563 13.9258 0.204301 12.6367 0.204301 11.05C0.204301 10.1433 0.354122 9.29333 0.653763 8.5C0.980645 7.67833 1.44373 6.94167 2.04301 6.29C2.64229 5.63833 3.35054 5.08583 4.16774 4.6325C4.98495 4.17917 5.91111 3.83917 6.94624 3.6125V0H12.2581V3.825C13.1842 4.05167 14.0151 4.42 14.7505 4.93C15.5133 5.41167 16.1534 6.00667 16.671 6.715C17.2158 7.42333 17.638 8.21667 17.9376 9.095C18.2373 9.97333 18.3871 10.9083 18.3871 11.9L12.6667 12.325C12.6667 11.2483 12.3806 10.4125 11.8086 9.8175C11.2366 9.2225 10.433 8.925 9.39785 8.925C8.47168 8.925 7.72258 9.19417 7.15054 9.7325C6.60573 10.2425 6.33333 10.8233 6.33333 11.475C6.33333 12.1267 6.64659 12.6225 7.27312 12.9625C7.89964 13.3025 8.67599 13.6283 9.60215 13.94C10.5556 14.2233 11.5771 14.535 12.6667 14.875C13.7563 15.215 14.7642 15.6967 15.6903 16.32C16.6437 16.9433 17.4337 17.765 18.0602 18.785C18.6867 19.805 19 21.1225 19 22.7375C19 23.6442 18.8366 24.5083 18.5097 25.33C18.21 26.1517 17.7606 26.9025 17.1613 27.5825C16.562 28.2625 15.8401 28.8575 14.9957 29.3675C14.1785 29.8492 13.2659 30.1892 12.2581 30.3875V34H6.94624V30.3875Z"
          fill="#A3ABB6"
        />
      </svg>
    </div>
    <div class="t-title sm mb-l">Your Trip Budget</div>

    <div class="grid-container">
      <div class="tooggle-wrapper">
        <ToggleBox label="Flights" :isActive="activeToggles['FLIGHT']" @click="onToggle($event, 'FLIGHT')">
          <div class="ui-input-wrapper">
            <input-wrapper label="Roundtrip Flight" class="input-holder">
              <label class="input-label">
                <Input
                  :class="{disabled: !activeToggles['FLIGHT']}"
                  class="rounded-input"
                  type="number"
                  step="100"
                  :value="localValue.flight"
                  @change="onValueChange($event, 'flight')"
                  :validators="[valueValidator]"
                />
                <span> {{ localValue.flight === 'Select Budget...' ? 'Select Budget...' : '$' }}</span>
              </label>
            </input-wrapper>
          </div>
        </ToggleBox>
      </div>
      <div class="tooggle-wrapper">
        <ToggleBox label="Stays" :isActive="activeToggles['STAY']" @click="onToggle($event, 'STAY')">
          <div class="ui-input-wrapper">
            <input-wrapper label="Per Night" class="input-holder">
              <label class="input-label">
                <Input
                  :class="{disabled: !activeToggles['STAY']}"
                  class="rounded-input"
                  type="number"
                  step="100"
                  :value="localValue.stay"
                  @change="onValueChange($event, 'stay')"
                  :validators="[valueValidator]"
                  :disabled="!activeToggles['STAY']"
                />
                <span> {{ localValue.stay === 'Select Budget...' ? 'Select Budget...' : '$' }}</span>
              </label>
            </input-wrapper>
          </div>
        </ToggleBox>
      </div>
      <div class="tooggle-wrapper">
        <ToggleBox label="Dining" :isActive="activeToggles['DINE']" @click="onToggle($event, 'DINE')">
          <div class="ui-input-wrapper">
            <Dropdown
              class="ui-dropdown-wrapper"
              :class="{disabled: !activeToggles['DINE']}"
              :value="localValue.dine"
              @change="onValueChange($event, 'dine')"
              category="Expensive Rating"
              :options="options"
            />
          </div>
        </ToggleBox>
      </div>
      <div class="tooggle-wrapper">
        <ToggleBox label="Experiences" :isActive="activeToggles['EXPERIENCE']" @click="onToggle($event, 'EXPERIENCE')">
          <div class="ui-input-wrapper">
            <Dropdown
              class="ui-dropdown-wrapper"
              :class="{disabled: !activeToggles['EXPERIENCE']}"
              :value="localValue.experience"
              @change="onValueChange($event, 'experience')"
              category="Booking Cost"
              :options="options"
            />
          </div>
        </ToggleBox>
      </div>
    </div>

    <BaseBtn class="btn amex-primary" @click="onClose">Let's go</BaseBtn>
  </div>
</template>

<script>
import ToggleBox from '../time-filter/toggle-box.vue';
import InputWrapper from '../time-filter/input-wrapper.vue';
import Input from '../time-filter/input.vue';
import Dropdown from '@common/filter/interest-filter/dropdown';
import BaseBtn from '@common/button/button.vue';
import {budgetDefultValue, budgetToggleDefaultState} from './budget.types';

export default {
  components: {
    InputWrapper,
    Input,
    ToggleBox,
    Dropdown,
    BaseBtn,
  },
  name: 'BudgetFilter',
  props: {
    value: {
      type: Object,
      default: () => ({...budgetDefultValue}),
    },
    toggleState: {
      type: Object,
      default: () => ({...budgetToggleDefaultState}),
    },
  },
  data() {
    return {
      localValue: {...budgetDefultValue},
      activeToggles: {...budgetToggleDefaultState},
      options: [budgetDefultValue.dine, '$', '$$', '$$$', '$$$$', '$$$$$'].map((x) => ({
        label: x,
        value: x,
        key: x,
        disabled: false,
      })),
    };
  },
  mounted() {
    this.localValue = this.value ? {...budgetDefultValue, ...this.value} : {...budgetDefultValue};
    this.activeToggles = this.toggleState
      ? {
          STAY: this.toggleState.STAY,
          EXPERIENCE: this.toggleState.EXPERIENCE,
          DINE: this.toggleState.DINE,
          FLIGHT: this.toggleState.FLIGHT,
        }
      : {...budgetToggleDefaultState};
    this.$emit('change', {...this.localValue, ...this.activeToggles});
  },
  methods: {
    valueValidator(value = '') {
      const number = parseInt(value.toString(), 10);
      if (value === '' || value === '0' || number === 0) {
        return true;
      }
      return number > 0;
    },
    onValueChange(value, kind) {
      this.localValue = {
        ...this.localValue,
        [kind]: value,
      };
      this.$emit('change', {...this.localValue, ...this.activeToggles});
    },
    onToggle(event, kind) {
      const origin = event.target;
      if (origin && origin.dataset.id === 'toggle' && this.activeToggles[kind]) {
        this.activeToggles[kind] = false;
        this.localValue[kind.toLowerCase()] = budgetDefultValue[kind.toLowerCase()];
        this.$emit('change', {...this.localValue, ...this.activeToggles});
        return;
      }
      this.activeToggles[kind] = true;
      this.$emit('change', {...this.localValue, ...this.activeToggles});
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.tooggle-wrapper {
  display: flex;
}

.ui-input-wrapper {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 20px;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.ui-dropdown-wrapper {
  --dropdown-border: none;
  padding-left: 20px;
  padding-right: 10px;
  background: #fff;
  border-radius: 20px;
}

.input-holder {
  padding: 0;
  position: relative;
}

.disabled {
  background: #f7f7f7;
  color: rgba(0, 0, 0, 0.5);
}

.rounded-input {
  border-radius: 20px;
  font-size: 18px;
  height: 55px;
  line-height: 55px;
  padding: 20px 20px 0 30px;
}

.input-label > span {
  position: absolute;
  left: 20px;
  bottom: 7px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 18px;
  transition: opacity 0.2s linear;
}

.btn {
  margin-left: auto;
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  margin-top: 30px;
}

.btn.amex-primary {
  background: var(--btn-primary-color, hsl(214, 64%, 48%));
  border-radius: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 118.14%;
  text-align: center;
  letter-spacing: -0.005em;

  color: #ffffff;
  padding: 12px 100px 10px;
}

.btn.amex-primary:hover {
  background: var(--btn-primary-color-active, hsl(214, 64%, 30%));
}

.icon {
  margin-bottom: 15px;
}
</style>
